/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { UserSettingsDisplayModel as AceXFoundPortalCoreCaqModelsUserSettingsDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/user-settings-display-model';
import { GetUserSettingsResponse as AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse } from '../models/ace/xFound/Portal/Core/CAQ/UserSettings/Queries/get-user-settings-response';

@Injectable({
providedIn: 'root',
})

export class UserSettingsService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiUserSettingsGet
   */
  static readonly ApiUserSettingsGetPath = '/api/UserSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserSettingsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserSettingsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UserSettingsService.ApiUserSettingsGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiUserSettingsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserSettingsGet$Plain(params?: {
  }): Observable<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse> {

    return this.apiUserSettingsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse>) => r.body as AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserSettingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserSettingsGet$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UserSettingsService.ApiUserSettingsGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiUserSettingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserSettingsGet(params?: {
  }): Observable<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse> {

    return this.apiUserSettingsGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse>) => r.body as AceXFoundPortalCoreCaqUserSettingsQueriesGetUserSettingsResponse)
    );
  }

  /**
   * Path part for operation apiUserSettingsPost
   */
  static readonly ApiUserSettingsPostPath = '/api/UserSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserSettingsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserSettingsPost$Response(params?: {
    body?: AceXFoundPortalCoreCaqModelsUserSettingsDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UserSettingsService.ApiUserSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiUserSettingsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserSettingsPost(params?: {
    body?: AceXFoundPortalCoreCaqModelsUserSettingsDisplayModel
  }): Observable<void> {

    return this.apiUserSettingsPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}